import { createImg } from "../../../DomUtilities/ElementsCreator";
import Service from "../../../Models/Service";
import { ServiceType } from "../../../Models/ServiceType";
import Variant from "../../../Models/Variant";
import { isNumber } from "../../../Validations/Validations";
import UpdateOrder from "../../../Models/UpdateOrder/UpdateOrder";
import UpdateService from "../../../Models/UpdateOrder/UpdateService";
import UpdateVariant from "../../../Models/UpdateOrder/UpdateVariant";
import Item from "../../../Models/Item";
import UpdateItem from "../../../Models/UpdateOrder/UpdateItem";

export default class ServiceVariantList {
	container: HTMLUListElement;
	service: Array<Service>;
	updatedOrder: UpdateOrder;
	item: Item;
	readonly MINIMUM_COST: number = 0;

	constructor(container: HTMLUListElement, service: Array<Service>, updatedOrder: UpdateOrder, item: Item) {
		this.container = container;
		this.service = service;
		this.updatedOrder = updatedOrder;
		this.item = item;

		this.init();
	}

	private init() {
		this.service.forEach((service: Service) => {
			service.variants.forEach((variant: Variant) => {
				const name = this.getServiceVariantName(service, variant);
				this.createserviceVariantTile(service, variant, name);
			});
		});
	}

	private createserviceVariantTile(service: Service, variant: Variant, name: string) {
		const variantList = document.createElement('li');
		const expandIconSrc: string = "/assets/chevron_right.svg";
		const variantName = document.createTextNode(`${name}`);
		const spanExpand = document.createElement('span');
		const spanInput = document.createElement('span');

		spanExpand.appendChild(variantName);
		spanInput.classList.add('custom-input-number')

		const variantInputNumber = document.createElement('input');
		variantInputNumber.type = 'number';
		variantInputNumber.value = `${variant.cost}`;
		variantInputNumber.min = `${this.MINIMUM_COST}`;

		const customInput = document.createElement('div');
		customInput.classList.add('input-number');
		const increaseIcon = createImg(expandIconSrc, 'increase icon');
		const decreaseIcon = createImg(expandIconSrc, 'increase icon');
		const br = document.createElement('br');

		customInput.appendChild(increaseIcon);
		customInput.appendChild(br);
		customInput.appendChild(decreaseIcon);

		spanInput.appendChild(variantInputNumber);
		spanInput.appendChild(customInput);

		variantList.appendChild(spanExpand);
		variantList.appendChild(spanInput);

		this.container.appendChild(variantList);
		this.addInputdNumberEventListeners(variantInputNumber, increaseIcon, decreaseIcon, service, variant);
	}

	private getServiceVariantName(service: Service, variant: Variant) {
		if (service.type == ServiceType.Canvas) {
			return service.name;
		}

		let mesurementValue: string = '';

		if (variant.cmDown) {
			mesurementValue = `${variant.cmDown} + cm`;
		}
		else if (variant.cmUp) {
			mesurementValue = `${variant.cmUp} - cm`;
		}
		else if (variant.byNeedle) {
			mesurementValue = ", Markeret m. nål";
		}

		return `${service.name} : ${variant.name} ${mesurementValue}`;
	}

	private isValidCost(value: string): boolean {
		const cost = Number(value);
		return !!value && !isNaN(cost) && cost >= this.MINIMUM_COST;
	}

	private addInputdNumberEventListeners(input: HTMLInputElement, increase: HTMLImageElement, decrease: HTMLImageElement, service: Service, variant: Variant) {
		increase.onclick = () => {
			const newValue = `${parseFloat(input.value) + 1}`;
			if (this.isValidCost(newValue)) {
				input.value = newValue;
				this.updateVariantCost(service, variant, Number(input.value));
			}
		}

		decrease.onclick = () => {
			const newValue = `${parseFloat(input.value) - 1}`;
			if (this.isValidCost(newValue)) {
				input.value = newValue;
				this.updateVariantCost(service, variant, Number(input.value));
			}
		}

		input.onkeypress = (event) => {
			if (!isNumber(event.key)) {
				event.preventDefault();
			}
		}

		input.onkeyup = () => {
			if (!input.value) {
				input.value = "0";
			}

			this.updateVariantCost(service, variant, Number(input.value));
		}
	}

	private updateVariantCost(service: Service, variant: Variant, newCost: number) {
		let updatedItem = this.updatedOrder.items.find((item) => item.id === this.item.id);
		if (!updatedItem) {
			updatedItem = new UpdateItem(this.item.id, this.item.count);
			this.updatedOrder.items.push(updatedItem);
		}

		let updatedService = updatedItem.services.find((s) => s.id === service.id);
		if (!updatedService) {
			updatedService = new UpdateService(service.id);
			updatedItem.services.push(updatedService);
		}

		let updatedVariant = updatedService.variants.find((v) => v.id === variant.id);

		if (!updatedVariant) {
			updatedVariant = new UpdateVariant(variant.id, newCost);
			updatedService.variants.push(updatedVariant);
		}

		if (newCost === variant.cost) {
			updatedService.variants = updatedService.variants.filter((v: UpdateVariant) => v.id !== variant.id);

			if (updatedService.variants.length === 0) {
				updatedItem.services = updatedItem.services.filter((s) => {
					return s.id !== service.id;
				});
			}

			if (updatedItem.services.length === 0 && this.item.count === updatedItem.count) {
				this.updatedOrder.items = this.updatedOrder.items.filter((item) => {
					return item.id !== this.item.id;
				});
			}
		} else {
			updatedVariant.cost = newCost;
		}
	}
}
